import { styled } from '@mui/material';
import { Container, Panel, Stack, Text } from 'shell/components';

const Tablet = ({ options, selected, onBeforeChange, onChange }) => {
    return (
        <CustomContainer device={'tablet'}>
            <Stack spacing={2}>
                <Text component={'h1'} variant={'h6'} weight={'medium'}>
                    Course Settings
                </Text>
                <CustomPanel
                    options={options}
                    selected={selected}
                    onBeforeChange={onBeforeChange}
                    onChange={onChange}
                />
            </Stack>
        </CustomContainer>
    );
};

const CustomContainer = styled(Container)(() => {
    return {
        display: 'block',
        height: 'unset',
    };
});

const CustomPanel = styled(Panel)(() => {
    return {
        minHeight: '100%',
        height: 'auto',
    };
});

export default Tablet;
